// writer.js

var M = {
  started: false,
  m: 0,
  i: 0,
  txt: [
    'Welcome to the bored shop!',
    'Get your board today!',
    'Skateboard with grip tape!',
    'Never skateboard!'
  ],
  speed: 50,
  interval: 5000,
  elem: undefined,
  init: function(elem) {
    this.elem = elem
    this.elem.innerHTML = ""
    return this
  },
  nextChar: function() {
    var el = document.getElementById(this.elem)
    if (el === null) { return }
    el.innerHTML += this.txt[this.m].charAt(this.i++);
  },
  nextTxt: function() {
    var el = document.getElementById(this.elem)
    if (el === null) { return }
    el.innerHTML = ""
    this.i = 0
    this.m = (++this.m % this.txt.length)
  },
  messenger: function(m) {
    if (m.i < m.txt[m.m].length) {
      m.nextChar()
      setTimeout(m.messenger, m.speed, m)
    }
  },
  start: function() {
    if (this.started === true) { return }
    this.started = true
    this.m = 0
    this.i = 0
    setInterval(function(m) {
      m.nextTxt()
      m.messenger(m)
    }, this.interval, this)
    this.messenger(this)
  }
}

document.addEventListener("turbolinks:load", function() {
  M.init("themessage").start()
})
